<template>
  <div class="view-post">
    <ViewPost/>
  </div>
</template>

<script>
// @ is an alias to /src
import ViewPost from '@/components/ViewPost.vue'

export default {
  name: 'ViewPostPage',
  components: {
    ViewPost
  }
}
</script>
